import type { JSX } from 'react';

import { cx } from '@emotion/css';
import { AccountHolderAddressDto } from 'src/dtos';
import { ClientServicesLink } from 'src/lib';

import { Font, Spacing } from '../styles';

export const renderAddressMismatchErrorMessage = ({
  address,
  onClick,
  section,
}: {
  address: AccountHolderAddressDto;
  onClick: () => void;
  section: string;
}): JSX.Element => {
  const { address1, address2, city, state, postalCode } = address;
  const addressString = [address1, address2, city, state, postalCode].filter(Boolean).join(', ');

  return (
    <p data-testid={`${section.replace(' ', '-')}-invalid-address-section`}>
      Invalid {section} address. USPS found the following address: <br />
      {addressString}. <br />
      If the address is correct, please click{' '}
      <a onClick={onClick} className={cx(Spacing.p4, Font.lg)}>
        here
      </a>{' '}
      to update the form.
    </p>
  );
};

export const renderAddressNotFoundErrorMessage = (): JSX.Element => (
  <p data-testid={`usps-address-not-found-section`}>
    Invalid address. USPS did not find address as it does not contain a valid combination of City, State and Postal
    Code. Please contact <ClientServicesLink /> to resolve. You will not be able to &quot;Save&quot; or Complete this
    application until address is resolved.
  </p>
);

export const renderNetworkErrorMessage = (): JSX.Element => (
  <p>
    There was an error connecting to the server. Please make sure that your Internet connection is stable and try again.
    If the problem persists, please try refreshing the page or contact <ClientServicesLink />.
  </p>
);

export const renderUnknownErrorMessage = (value: any): JSX.Element => {
  if (value?.message) {
    return (
      <p>
        Unknown error occurred (error: {value.message}). Please try again later. If the problem persists, please contact{' '}
        <ClientServicesLink /> to resolve.
      </p>
    );
  }

  return (
    <p>
      Unknown error occurred(error: {value}). Please try again later or contact <ClientServicesLink /> to resolve.
    </p>
  );
};
